module.exports = __webpack_public_path__ + "19473c414ce929b0fa16bf853b05757c.png";